import Mobile from './index.vue'
import Guwen from './guwen.vue'

export default [{
    path: '/mobile',
    name:'mobile',
    component:Mobile
}, {
    path: '/guwen',
    name:'guwen',
    component:Guwen
}]